import { getAccountTitleKeyBySlug } from '../../layouts/AccountLayout';
import { getSettingTitleKeyBySlug } from '../../utils/settingSections/settingSections';
import { FALLBACK_ROUTE_TITLE_KEY, routeTitleRules } from './routeTitleRules';

const SETTINGS_HUB_TITLE_KEY = 'pageTitle.settings';
const ACCOUNT_HUB_TITLE_KEY = 'pageTitle.account';

/** Match pathname to an i18n key (settings/account slug → hub title key, else prefix rules). */
export function resolveRouteTitleKey(pathname: string): string {
  const path = pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;

  if (path === '/settings') {
    return SETTINGS_HUB_TITLE_KEY;
  }

  if (path.startsWith('/settings/')) {
    const slug = path.slice('/settings/'.length);
    // ponytail: single-segment slugs only; nested/unknown → hub title
    if (slug && !slug.includes('/')) {
      const settingTitleKey = getSettingTitleKeyBySlug(slug);
      if (settingTitleKey) return settingTitleKey;
    }
    return SETTINGS_HUB_TITLE_KEY;
  }

  if (path === '/account') {
    return ACCOUNT_HUB_TITLE_KEY;
  }

  if (path.startsWith('/account/')) {
    const slug = path.slice('/account/'.length);
    // ponytail: single-segment slugs only; nested/unknown → hub title
    if (slug && !slug.includes('/')) {
      const accountTitleKey = getAccountTitleKeyBySlug(slug);
      if (accountTitleKey) return accountTitleKey;
    }
    return ACCOUNT_HUB_TITLE_KEY;
  }

  for (const rule of routeTitleRules) {
    if (path === rule.prefix || path.startsWith(`${rule.prefix}/`)) {
      return rule.titleKey;
    }
  }
  return FALLBACK_ROUTE_TITLE_KEY;
}
